import React, { useState } from 'react';
import '../styles/OAuthButtons.css';
import { oauthCallback } from '../api/auth';

function OAuthButtons({ onSuccess }) {
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState('');

  // Google OAuth handler
  const handleGoogleAuth = async () => {
    setLoading('google');
    setError('');
    try {
      // In production, this would use @react-oauth/google library
      // For now, we'll implement a basic OAuth flow
      const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
      const redirectUri = `${window.location.origin}/oauth/callback`;
      const scope = 'openid profile email contacts.readonly';

      const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
      authUrl.searchParams.append('client_id', clientId);
      authUrl.searchParams.append('redirect_uri', redirectUri);
      authUrl.searchParams.append('response_type', 'code');
      authUrl.searchParams.append('scope', scope);

      window.location.href = authUrl.toString();
    } catch (err) {
      setError('Google authentication failed');
      setLoading(null);
    }
  };

  // Microsoft OAuth handler
  const handleMicrosoftAuth = async () => {
    setLoading('microsoft');
    setError('');
    try {
      const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
      const redirectUri = `${window.location.origin}/oauth/callback`;
      const scope = 'Contacts.Read openid profile email';

      const authUrl = new URL('https://login.microsoftonline.com/common/oauth2/v2.0/authorize');
      authUrl.searchParams.append('client_id', clientId);
      authUrl.searchParams.append('redirect_uri', redirectUri);
      authUrl.searchParams.append('response_type', 'code');
      authUrl.searchParams.append('scope', scope);
      authUrl.searchParams.append('prompt', 'login');

      window.location.href = authUrl.toString();
    } catch (err) {
      setError('Microsoft authentication failed');
      setLoading(null);
    }
  };

  // Apple OAuth handler
  const handleAppleAuth = async () => {
    setLoading('apple');
    setError('');
    try {
      const clientId = process.env.REACT_APP_APPLE_CLIENT_ID;
      const redirectUri = `${window.location.origin}/oauth/callback`;

      const authUrl = new URL('https://appleid.apple.com/auth/authorize');
      authUrl.searchParams.append('client_id', clientId);
      authUrl.searchParams.append('redirect_uri', redirectUri);
      authUrl.searchParams.append('response_type', 'code id_token');
      authUrl.searchParams.append('scope', 'name email');
      authUrl.searchParams.append('response_mode', 'form_post');

      window.location.href = authUrl.toString();
    } catch (err) {
      setError('Apple authentication failed');
      setLoading(null);
    }
  };

  return (
    <div className="oauth-buttons">
      <button
        className="oauth-btn google-btn"
        onClick={handleGoogleAuth}
        disabled={loading !== null}
      >
        {loading === 'google' ? '⏳ Google...' : '🔍 Google'}
      </button>

      <button
        className="oauth-btn microsoft-btn"
        onClick={handleMicrosoftAuth}
        disabled={loading !== null}
      >
        {loading === 'microsoft' ? '⏳ Microsoft...' : '🪟 Microsoft'}
      </button>

      <button
        className="oauth-btn apple-btn"
        onClick={handleAppleAuth}
        disabled={loading !== null}
      >
        {loading === 'apple' ? '⏳ Apple...' : '🍎 Apple'}
      </button>

      {error && <div className="oauth-error">{error}</div>}
    </div>
  );
}

export default OAuthButtons;
